import { render, staticRenderFns } from "./projectDesDialog.vue?vue&type=template&id=72077474&"
import script from "./projectDesDialog.vue?vue&type=script&lang=js&"
export * from "./projectDesDialog.vue?vue&type=script&lang=js&"
import style0 from "./projectDesDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports